<div *ngIf="status" class="loader-wrapper">
    <div class="loader-body">
        <div class="loader">
            <div></div><div></div><div></div>
        </div>
    </div>
</div>